import React from "react";
import { IoCheckmarkCircleSharp } from "react-icons/io5";

const Success = ({ formConfirmationText }) => {
  return (
    <div
      style={{
        height: "424px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <span style={{ fontSize: "24px", fontWeight: 900, lineHeight: "20px" }}>
        <IoCheckmarkCircleSharp />
      </span>
      <span
        style={{
          fontSize: "1rem",
          fontWeight: 400,
          lineHeight: "24px",
          height: "24px",
          fontFamily:"Inter"
        }}
      >
        {formConfirmationText}
      </span>
    </div>
  );
};

export default Success;
